<template>
  <div id="line" style="width: 100%; height: 100%"></div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "ChartLine",
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.chart = this.$echarts.init(document.getElementById("line"));
    window.addEventListener("resize", () => {
      if (this.chart) {
        this.chart.resize();
      }
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart(data) {
      let datas1 = []; // 日期
      let datas2 = []; // 失败
      let datas3 = []; // 成功
      if (data && data.length > 0) {
        data.forEach((item) => {
          datas1.push(item.month);
          datas2.push(item.failNum);
          datas3.push(item.successNum);
        });
      }
      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "10%",
          containLabel: true,
        },
        xAxis: {
          boundaryGap: false,
          data: datas1,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#0C4F81",
            },
          },
          axisLabel: {
            show: true, //
            color: "#0C4F81",
            fontSize: "0.12rem",
          },
          splitLine: {
            show: false,
            lineStyle: {
              type: "solid",
              color: "rgba(97,97,97,0.5)",
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          axisLine: {
            show: false,
          },
          axisLabel: {
            color: "#A0AEC0",
            fontSize: "0.12rem",
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "solid",
              color: "#F1F2F4",
            },
          },
          axisTick: {
            show: false,
            alignWithLabel: true,
            lineStyle: {
              color: "#0C4F81",
              type: "solid",
            },
          },
        },
        series: [
          {
            name: "抢单失败",
            type: "line",
            stack: "Total",
            smooth: true,
            showSymbol: false,
            lineStyle: {
              color: "#ee6666", // 折线颜色
              width: 2, // 折线宽度
              // 其他样式属性
            },
            data: datas2,
          },
          {
            name: "抢单成功",
            type: "line",
            stack: "Total",
            smooth: true,
            showSymbol: false,
            lineStyle: {
              color: "#0CAF60", // 折线颜色
              width: 2, // 折线宽度
              // 其他样式属性
            },
            data: datas3,
          },
        ],
      };
      this.chart.setOption(option);
    },
  },
};
</script>
